import { connect } from 'react-redux'
import GroupsComponent from './groups-component'
import {
  getGroupsFetchingStatus,
  getGroupsArray,
  getCategories
} from '../../../../stores/groups/groups.selectors'
import { fetchGroups } from '../../../../stores/groups/groups.actions'
import { getSelectedGroups } from '../../pupils-component-redux/pupils-component.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => ({
  pending: getGroupsFetchingStatus(state).pending,
  categories: getCategories(state),
  groups: getGroupsArray(state),
  selectedGroups: getSelectedGroups(state)
})

const mapDispatchToProps = (dispatch, { me }) => ({
  onMount: () =>
    dispatch(fetchGroups(me.account.teacher_type.school.id)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GroupsComponent)
)
